import React from "react";
import Trip from "../Trip";

let TripList = ({ trips, onTripSelect, tripSegmentHeader }) => {
  var renderTrips = [];

  if (trips) {
    //   for (const id in trips) { // Const, so we don't return the same id for all Trips in onSelectBtnClick
    //     if (trips.hasOwnProperty(id)) { // Ensure we aren't using properties from prototype
    //       renderTrips.push(<Trip data={trips[id]} key={id} onSelectBtnClick={() => onTripSelect(id)} />)
    //     }
    //   }
    renderTrips = trips.map(
      ({ id: tripId, ppnContractBundle, ppnReturnBundle, ...tripData }) => (
        <Trip
          tripSegmentHeader={tripSegmentHeader}
          data={tripData}
          key={tripId}
          onSelectBtnClick={() =>
            onTripSelect({
              tripId,
              ppnContractBundle,
              ppnReturnBundle /*ppnReturnBundle valid only in round trip */
            })
          }
        />
      )
    );
  }

  return <div> {renderTrips} </div>;
};

export default TripList;



// WEBPACK FOOTER //
// ./src/scenes/SearchResultsPage/components/TripList/index.js